let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cLbW0")).then(() => parcelRequire('lHFFD'));